import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noRolesMessage: {
		id: 'users-and-roles.common.roles-picker.no-roles-message',
		defaultMessage: '-',
		description: 'Shown in the roles picker when a user has no roles assigned',
	},
	selectRolesAriaLabel: {
		id: 'users-and-roles.common.roles-picker.select-roles-aria-label',
		defaultMessage: 'Select roles',
		description: 'aria-label for the roles combobox',
	},
	manageRoles: {
		id: 'users-and-roles.common.roles-picker.manage-roles',
		defaultMessage: 'Manage roles',
		description: 'Label stating to open manage roles modal for next-gen projects',
	},
	roleDisabledValidation: {
		id: 'users-and-roles.common.roles-picker.role-disabled-validation',
		defaultMessage: 'A user must have at least 1 role assigned to them.',
		description: 'Shown in the roles picker when user hovered over disabled role',
	},
	roleSelected: {
		id: 'users-and-roles.common.roles-picker.role-selected',
		defaultMessage: 'Selected',
		description: 'Shown in the roles picker when role is selected',
	},
	roleDisabled: {
		id: 'users-and-roles.common.roles-picker.role-disabled',
		defaultMessage: 'Disabled',
		description: 'Shown in the roles picker when role is disabled',
	},
});
